/**
 * Content rendered inside a Tooltip when the anchor is a player badge.
 * Avatar + name + subtitle + optional this-game line + "View profile"
 * button that opens the full PlayerModal.
 */
import PlayerAvatar from './PlayerAvatar';
import styles from './PlayerTooltipCard.module.css';

interface PlayerTooltipCardProps {
  personId: number | null | undefined;
  name: string;
  /** Short subtitle line: typically position + jersey ("RF · #4") */
  subtitle?: string;
  /** Optional this-game line such as "0-4 | K" or "5.0 IP · 6 K · 1 ER" */
  summary?: string;
  onOpenProfile: () => void;
}

export default function PlayerTooltipCard({
  personId,
  name,
  subtitle,
  summary,
  onOpenProfile,
}: PlayerTooltipCardProps): JSX.Element {
  return (
    <div className={styles.card} data-testid="player-tooltip-card">
      <div className={styles.header}>
        <PlayerAvatar personId={personId} name={name} size={240} displaySize={56} className={styles.avatar} />
        <div className={styles.text}>
          <div className={styles.name}>{name}</div>
          {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
      </div>
      {summary && <div className={styles.summary}>{summary}</div>}
      <button
        type="button"
        onClick={onOpenProfile}
        className={styles.profileLink}
        data-testid="player-tooltip-profile"
      >
        View profile →
      </button>
    </div>
  );
}
